<!-- src/components/research/LifeCare.vue -->
<template>
  <div class="life-care-container">
    <!-- 左侧内容区 -->
    <div class="left-content">
      <div class="icon-wrapper">
        <span class="icon-number">
          <img :src="require('@/assets/' + imageUrl + '.png')" alt="" srcset="">
        </span>
        <div class="title">{{ title }}</div>
      </div>
      <p class="description">
        {{ description }}
      </p>
      <button class="learn-more-btn">了解更多 →</button>
    </div>

    <!-- 右侧图片 -->
    <div class="right-image">
      <img :src="require('@/assets/' + cover + '.png')" alt="生活照料" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LifeCare',
  props: {
    imageUrl: {
      type: String,
      default: 'icon_volunteer' // 默认图片路径
    },
    title: {
      type: String,
      default: '生活照料'
    },
    description: {
      type: String,
      default: ' '
    },
    cover: {
      type: String,
    }
  }
}
</script>

<style scoped lang="scss">
.life-care-container {
  width: 76vw;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  overflow: hidden;

  .left-content {
    width: 38rem;
    margin: 4rem 0 0 3.2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-sizing: border-box;
    line-height: 1.6rem;

    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: white;
      font-weight: bold;
      font-size: 1.2rem;
      margin-bottom: 0.5rem;

      .icon-number {
        display: flex;
        align-items: center;

        img {
          width: 80%;
        }
      }
    }

    .title {
      font-size: 2.2rem;
      color: #ff7000;
      font-weight: normal;
    }

    .description {
      font-size: 1.2rem;
      line-height: 1.2rem;
      color: #3b3b3b;
      font-weight: 400;
      letter-spacing: 5px;
      margin: 1rem 0 9rem;
    }

    .learn-more-btn {
      width: 40%;
      padding: 0.5rem 1rem;
      border: 1px solid #ff7000;
      background: transparent;
      color: #ff7000;
      font-size: 0.9rem;
      cursor: pointer;
      border-radius: 4px;
      transition: all 0.3s;
      &:hover {
        background-color: #ff7000;
        color: white;
      }
    }
  }

  .right-image {
    width: 38vw;
    height: 26vw;
    margin-left: 8rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      object-fit: cover;
      transition: all 0.4s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    .left-content {
      width: 100%;
      text-align: center;
      .icon-wrapper {
        margin: 0 auto;
      }
    }
    .right-image {
      width: 100%;
      margin: 1rem 0;
    }
  }
}
</style>